module.exports = __webpack_public_path__ + "media/images/icon__whatsapp@3x-83d32fbbc66d86c710218b13386319bf.png";